export default {"src":"/_next/static/media/arrow-up-blue.5763ce1b.svg","height":10,"width":15,"blurWidth":0,"blurHeight":0};